export const INITIAL_PALLET_AMOUNTS = () => ({
   EDHP_PALLET: 0,
   EURO_PALLET: 0,
   HALF_PALLET_NDHP: 0,
   QUARTER_PALLET_CDHP: 0,
});
